module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    class: [("" + _vm.situacaoClass), 'white--text', 'ma-0', 'caption'],
    attrs: {
      "block": ""
    }
  }, [_vm._t("default", [_vm._v("Vistoria " + _vm._s(_vm.situacao))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ecb6356"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Lista/ListaVistoriaSituacao.vue
// module id = 1037
// module chunks = 1